// extracted by mini-css-extract-plugin
export var attachmentContainer = "_j4-0";
export var fileList = "_j4-2";
export var removeFileButton = "_j4-1";